"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderDocxAsync = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../law/std"));
const law_1 = require("./rules/law");
const file_1 = require("./common/docx/file");
const any_1 = require("./rules/any");
const loadEL_1 = __importDefault(require("../node/el/loadEL"));
const renderDocxAsync = (elOrJsonEL, docxOptions) => {
    const el = (0, loadEL_1.default)(elOrJsonEL);
    const element = std.isLaw(el)
        ? react_1.default.createElement(law_1.DOCXLaw, { el: el, indent: 0, docxOptions: docxOptions ?? {} })
        : react_1.default.createElement(any_1.DOCXAnyELs, { els: [el], indent: 0, docxOptions: docxOptions ?? {} });
    return (0, file_1.renderDocxAsync)(element, docxOptions);
};
exports.renderDocxAsync = renderDocxAsync;
exports.default = exports.renderDocxAsync;
//# sourceMappingURL=docx.js.map